import ProgrammaticDialog from '~/components/ProgrammaticDialog.js'
import ShareDialog from '~/plugins/board/components/ShareDialog/ShareDialog.vue'

export default ProgrammaticDialog(ShareDialog)
